<div class="toast" [@toastTrigger]="toast.showsToast$.value ? 'open' : 'close'"> 
  <div class="toast--info">
    <app-icon class="toast--info--icon" [src]="toastTypesEnumToIcon[toast.toastState$.value]" [style.color]="toastTypesEnumToColor[toast.toastState$.value]"></app-icon>
    <p><b>{{ toastTypesEnumToTitle[toast.toastState$.value] }}</b>{{ toast.toastMessage$.value }}</p>
  </div>

  <app-icon class="toast--close" (click)="dismiss()" src="/assets/icons/close.svg"></app-icon>
</div>